module.exports = __webpack_public_path__ + "static/media/dashboard4.235b0317.png";